<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             :ok-text="$t('common.confirm')"
             :ok-loading="cancelClosingPending"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.list.SigningChecklistCancelClosingDialog.title') }}</template>

    <template #body>
      <p>{{ $t('project.signing-checklist.list.SigningChecklistCancelClosingDialog.body.part1') }}</p>
      <p>{{ $t('project.signing-checklist.list.SigningChecklistCancelClosingDialog.body.part2') }}</p>
      <i18n-t keypath="project.signing-checklist.list.SigningChecklistCancelClosingDialog.body.part3"
              tag="p"
              scope="global"
              class="font-weight-bold"
        >
          <template v-slot:optionIcon>
            <font-awesome-icon :icon="['far', 'ellipsis-vertical']" class="mx-2"/>
          </template>
      </i18n-t>
    </template>
  </AppDialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { CANCEL_CLOSING } from '@/store/modules/signing-checklist/action_types'
const { mapState, mapActions } = createNamespacedHelpers('signingChecklist')

export default {
  name: 'SigningChecklistCancelClosingDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['cancelClosingPending']),
  },
  methods: {
    ...mapActions([CANCEL_CLOSING]),
    async confirmClick () {
      try {
        await this.CANCEL_CLOSING(this.mnemo)
        toast.success(this.$t('project.signing-checklist.list.SigningChecklistCancelClosingDialog.success'))
      } finally {
        this.$emit('confirm')
        this.closeDialog()
      }
    },
  },
}
</script>
